export function redirectToServerDown() {
  if (window.location.pathname !== "/server-down") {
    window.location.href = "/server-down";
  }
}

export function shouldRedirectToServerDown(errorOrResponse) {
  if (!errorOrResponse) return true;

  if (errorOrResponse instanceof Response) {
    return errorOrResponse.status >= 500;
  }

  return true;
}
